import { useEffect } from "react";
import GetFieldUI from "../../GetFieldUI";
import { getAutoCalculatedResults } from "../../../../../utils/Common";

export default function PropertyEconomics(props: any) {
  const {
    fieldConfig,
    detailedLoanSizingData,
    isApplicationSubmitted,
    client,
    handleChange,
    onBlur,
    propertyDetails,
    detailedLoanSizingErrors,
    propertyId,
  } = props;

  return (
    <div>
      <h4>Property Economics</h4>
      <GetFieldUI
        formFields={fieldConfig?.["propertyEconomics"]?.fields}
        currentObjValue={
          detailedLoanSizingData?.[
            fieldConfig?.["propertyEconomics"]?.header
          ] ?? {}
        }
        handleChange={handleChange}
        onBlur={onBlur}
        propertyDetails={propertyDetails}
        sectionName={fieldConfig?.["propertyEconomics"]?.header}
        zipCodeSuggestions={[]}
        currentObjFieldErrors={
          detailedLoanSizingErrors?.propertyDetails?.[propertyId]?.[
            fieldConfig?.["propertyEconomics"]?.header
          ] ?? {}
        }
        client={client}
        propertyId={propertyId}
        isApplicationSubmitted={isApplicationSubmitted}
      />
    </div>
  );
}
